import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const GroupTreeAttributeServiceConfig = {
  name: "GroupTreeAttribute",
  annotations: []
} as ServiceConfig;